<template>
  <div>
    <el-form :model="modifys">
      <el-row>
        <!-- <el-col :span="24"> -->
        <el-form-item v-for="x in fields" :key="x.name" :label="x.title"
          v-show="x.filterable != 'no' && x.visible != false" label-width="15%">
          <el-col :span="16">
            <el-date-picker v-if="x.type == 'daterange'" v-model="modifys[x.name]" type="date" value-format="yyyy-MM-dd"
              align="right"></el-date-picker>

            <el-input-number v-else-if="x.type == 'numberrange'" v-model="modifys[x.name]"></el-input-number>

            <el-input v-else v-model="modifys[x.name]" autocomplete="off" :clearable="true"></el-input>
          </el-col>
          <el-col :span="4">
            <el-button type="danger" @click="tomodifyall(x.name)">批量变更</el-button>
          </el-col>
        </el-form-item>
        <!-- </el-col> -->
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="2"> Eval</el-col>
     <el-col :span="4"><el-input v-model="eval_field" placeholder="输入自定义field name" ></el-input></el-col>
     <el-col :span="14"><el-input v-model="eval_value" placeholder="输入eval,可以引用的变量为item,注意，如果直接输入字符，需要加''"></el-input></el-col>
     <el-col :span="4"><el-button type="danger" @click="tomodifyall(eval_field,true)" >Eval批量变更</el-button></el-col>
  
    </el-row>
  </div>
</template>

<script>
import { fieldsprocess } from "zxg-table-fieldsprocess";
// import savesearch from "./savesearch"
export default {
  // components:{savesearch},
  mounted() {
    //  this.getstars()
  },
  data() {
    return {
      eval_field:"",
      eval_value:"",
      modifys: {},
    };
  },
  computed: {
    fields() {
      return fieldsprocess(this.$store.state.currentheader, "table",this.$store);
    },
  },
  methods: {
    tomodifyall(thekey,ifeval) {
      this.$confirm("确定更改所有数据吗", "Warning", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let query = {
            modifykey: thekey,
            ifeval:ifeval,
            modifyto: ifeval?this.eval_value:(this.modifys[thekey] || ""),
            matchrule: this.$store.state.matchrule,
            searchmodel: this.$store.state.searchmodel,
            collection: this.$store.state.collection.value,
            target: this.$store.state.targettxt, //for generalsearch
            fdata: this.$store.state.filter, //for filter
            ids: this.$store.state.fetchids, //for fetchbyids
          }
          this.$axios.post(url + "modifyall", query).then((res) => {
            this.modifys = {}; //重置modifys
            this.$emit("done")
            this.$message({
              type: "success",
              message: "变更完成",
            });
          });
        })
      // .catch(() => {
      //   this.$message({
      //     type: "info",
      //     message: "取消",
      //   });
      // });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/presentation/table/tomodify.vue